import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import get from 'lodash/get';
import { injectIntl } from 'react-intl';
import './styles.css';

import ListingImage from '../../../../../components/ListingImage';
import Link from '../../../../../components/SEO/Link';
import { getBoatsConstants } from '../../../../../constants/boats';
import { getSellerName } from '../../../../../utils/listingHelper';
import { listingPropTypes } from '../../../../../utils/commonPropTypes';
import { getEngineUrl } from '../../../../../utils/urlHelpers/engine';
import ContactForm from '../../../../../components/ContactForm';

import { setListingClick } from '../../../../../store/actions/dataLayer';
import { PRODUCT_CATEGORY } from '../../../../../constants/dataLayer';
import {getBoatConstantsFromI18n} from '../../../../../tppServices/translations/constants';
import { getMessages } from '../../../../../tppServices/translations/messages';

const ListingResult = (props) => {
  const [contactForm, setContactForm] = useState();
  const boatsConstants = getBoatConstantsFromI18n();
  const messages = getMessages();
  const getResize = () => {
    if (get(props.listing.featureType, 'enhanced', false)) {
      return getBoatsConstants().LISTING_RESIZES.rowEnhanced;
    }
    return getBoatsConstants().LISTING_RESIZES.default;
  };

  const getListingType = () => {
    const { listing } = props;
    return get(listing.featureType, 'enhanced', false)
      ? getBoatsConstants().LISTING_ENHANCED
      : getBoatsConstants().LISTING_STANDARD;
  };

  useEffect(() => {
    const { listing,  position, tracking, labels: { getTitle } } = props;
    const listingType = getListingType();
    const { id, make, model } = listing;
    tracking.setProductImpression(
      id,
      listingType,
      position.position,
      position.page,
      PRODUCT_CATEGORY.ENGINE,
      undefined,
      model,
      getTitle(listing),
      make
    );
  }, []);

  const handleContactButtonClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (contactForm) {
      setContactForm();
    } else {
      let { listing } = props;
      let contactData = {
        boatClass: listing.class,
        make: listing.make,
        listingType: boatsConstants.LISTING_ENHANCED,
        subdivision: listing.location.address.subdivision
      };
      setContactForm(
        <ContactForm
          key={listing.id}
          open
          itemId={listing.id}
          data={contactData}
          onClose={() => setContactForm()}
        />
      );
    }
  };

  const getDealerLogo = () => {
    const { listing } = props;
    return get(listing.owner, 'logos.enhanced', '').replace(
      /^http:\/\//,
      'https://'
    );
  };

  const getDealerName = () => {
    const { listing } = props;
    return get(listing.owner, 'name', '');
  };

  const {
    listing,
    position,
    intl: { formatMessage: t },
    labels
  } = props;
  const { getPrice, getTitle, getLocation } = labels;
  const title = getTitle(listing);
  const price = getPrice(listing);
  const listingType = getListingType();

  const resize = getResize();
  const location = getLocation(listing);

  const listingAnchorParamsDefault = {
    'data-reporting-click-product-id': listing.id,
    'data-reporting-click-listing-type': listingType,
    'data-reporting-rank': position.position,
    'data-reporting-page': position.page
  };
  const listingAnchorParams = {
    ...listingAnchorParamsDefault,
    href: getEngineUrl(listing)
  };

  const seller = getSellerName(listing.owner);

  return (
    <li
      className={classnames('listing-result', {
        'listing-result-enhanced': get(listing.featureType, 'enhanced', false)
      })}
      data-listing-id={listing.id}
      data-reporting-impression-product-id={listing.id}
      data-reporting-impression-listing-type={listingType}
      onClick={() => setListingClick(listing.id, listingType, '', '')}
    >
      {contactForm}
      <Link className="inner" {...listingAnchorParams}>
        <div className="image-container">
          <div className="dummy" />
          <div className="image">
            <ListingImage
              listing={listing}
              resize={resize}
              labels={labels}
              lazyLoad
            />
          </div>
        </div>
        <div className="description">
          <div className="top">
            <div className="name">
              <h2>{title}</h2>
            </div>
            <div className="price">{price}</div>
            <div className="location">{location}</div>
          </div>
          <div className="bottom">
            {listingType === getBoatsConstants().LISTING_ENHANCED ? (
              <>
                <div className="dealer">
                  {getDealerLogo() && (
                    <img
                      className="dealer-logo"
                      src={getDealerLogo()}
                      alt={getDealerName()}
                    />
                  )}
                  <div className="offered-by">
                    <span className="sold-by">
                      {t(messages.contactGroup.offeredBy) + ': '}
                    </span>
                    {seller}
                  </div>
                </div>
                <div className="contact">
                  <button
                    className="contact-seller"
                    {...listingAnchorParamsDefault}
                    onClick={handleContactButtonClick}
                  >
                    {t(messages.contactGroup.contact)}
                  </button>
                </div>
              </>
            ) : (
              <div className="offered-by">{seller}</div>
            )}
          </div>
        </div>
      </Link>
    </li>
  );
};

ListingResult.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  /** Helper functions to build listing labels */
  labels: PropTypes.shape({
    getLocation: PropTypes.func.isRequired,
    getPrice: PropTypes.func.isRequired,
    getTitle: PropTypes.func.isRequired
  }).isRequired,
  /** Listing information of the boat */
  listing: listingPropTypes.isRequired,
  /** Position within the results list */
  position: PropTypes.shape({
    position: PropTypes.number,
    page: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }).isRequired,
  /** Analytics tracking helper  */
  tracking: PropTypes.shape({
    setProductImpression: PropTypes.func.isRequired
  }).isRequired
};

export default injectIntl(ListingResult);
